import { Modal } from '@mantine/core'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { useRegisterNestedModal } from '@/components/ui-shared/NestedModal/NestedModalContext'

type MilestoneServerCreateModalProps = {
  opened: boolean
  onClose: () => void
  children: ReactNode
}

export const MilestoneServerCreateModal = ({
  opened,
  onClose,
  children
}: MilestoneServerCreateModalProps) => {
  useRegisterNestedModal(opened)

  return (
    <Modal
      size="lg"
      title={<FormattedMessage id="vlm.milestoneServers.create.title" />}
      opened={opened}
      onClose={onClose}
    >
      {children}
    </Modal>
  )
}
